import { useState } from "react";
import { DataTable } from "../../components/organisms/DataTable";
import { ProvinciaCard } from "./ProvinciaCard";
import { paginacion } from "../../utils/paginacion/paginacion";

const PROVINCIAS_POR_PAGINA = 15;

export const ProvinciaList = ({ provincias = [], onRefresh }) => {
  const [paginaActual, setPaginaActual] = useState(1);
  const [busqueda, setBusqueda] = useState("");

  const provinciasFiltradas = provincias.filter((provincia) => {
    const texto = busqueda.toLowerCase();
    return (
      provincia?.nombre?.toLowerCase().includes(texto) ||
      provincia?.departamento?.nombre?.toLowerCase().includes(texto)
    );
  });

  const {
    objetosEnPagina: provinciasEnPagina,
    paginas,
    paginaInicial,
    paginaFinal,
  } = paginacion(paginaActual, provinciasFiltradas, PROVINCIAS_POR_PAGINA);

  const columnas = ["#", "Nombre", "Departamento", "Opciones"];

  const handleDelete = (idProvincia) => {
    onRefresh?.();
  };

  return (
    <section className="px-4 pb-10 max-w-6xl mx-auto">
      <div className="flex justify-between items-center my-4">
        <input
          type="text"
          placeholder="Buscar por nombre o departamento..."
          value={busqueda}
          onChange={(e) => {
            setBusqueda(e.target.value);
            setPaginaActual(1);
          }}
          className="border border-gray-300 rounded px-4 py-2 w-full max-w-md"
        />
      </div>

      <DataTable
        columnas={columnas}
        paginas={paginas}
        paginaInicial={paginaInicial}
        paginaFinal={paginaFinal}
        paginaActual={paginaActual}
        setPaginaActual={setPaginaActual}
      >
        {provinciasEnPagina.length === 0 ? (
          <tr>
            <td colSpan={columnas.length} className="text-center py-8 text-gray-500">
              No hay provincias registradas
            </td>
          </tr>
        ) : (
          provinciasEnPagina.map((provincia, index) => (
            <ProvinciaCard
              key={provincia.idProvincia}
              provincia={provincia}
              index={paginaInicial + index}
              onDelete={handleDelete}
            />
          ))
        )}
      </DataTable>
    </section>
  );
};